import { Grid, TextButton } from '@tfo/common'
import { inject } from 'mobx-react'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useHistory } from 'react-router-dom'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import { MismatchViewModel } from '../../ViewModels'

import './Mismatch.scss'

type MismatchProps = MismatchViewModel

const { GridWrapper } = Grid

const Mismatch: React.FunctionComponent<MismatchProps &
	WrappedComponentProps> = props => {
	const {nationalId, companyName, orderId} = props
	const history = useHistory()
	return (
		<GridWrapper className={'IndividualView Mismatch'}>
			<IndividualHeader
				companyName={companyName}
				headingId="mismatch.heading"
				preambleId="mismatch.body"
				preambleData={{
					nationalId: nationalId,
					companyName: companyName,
				}}
			/>

			<div className={'IndividualButtons'}>
				<TextButton
					className="Mismatch__TextButton Mismatch__TextButton--left"
					onClick={() =>
						history.push(`/approval/${orderId}`)
					}>
					{props.intl.formatMessage({ id: 'mismatch.btn.change' })}
				</TextButton>
			</div>
		</GridWrapper>
	)
}

export default inject('rootStore')(injectIntl(Mismatch))
